/** EMP/Out ids that use 月給 distribution in payroll export only (not timer timesheets). */
export const PAYROLL_MONTHLY_EMP_OUT_IDS = new Set([
  "E000007-Chris",
  "E000012-Sacha",
  "E000025-Nadir",
]);

/** Default monthly target when API / roster does not specify otherwise. */
export const PAYROLL_DEFAULT_MONTHLY_HOURS = 155;

/**
 * Per-employee monthly hours for 月給 export (overrides API default 155).
 * 117 h/mo (~30 h/wk avg): part-time schedule; also drives default PTO day length.
 */
export const PAYROLL_MONTHLY_HOURS_BY_EMP_OUT_ID = {
  "E000007-Chris": 155,
  "E000012-Sacha": 155,
  "E000016-Sebastian": 117,
  "E000020-Tokiko": 117,
  "E000025-Nadir": 117,
  "E000026-Martin": 117,
};

export const PAYROLL_DEFAULT_PTO_DAY_HOURS = 8;
export const PAYROLL_PTO_DAY_HOURS_117_SCHEDULE = 6;

export function payrollMonthlyTargetHoursForEmpOutId(empOutId, apiHours) {
  const id = String(empOutId || "").trim();
  if (id && Object.prototype.hasOwnProperty.call(PAYROLL_MONTHLY_HOURS_BY_EMP_OUT_ID, id)) {
    return PAYROLL_MONTHLY_HOURS_BY_EMP_OUT_ID[id];
  }
  const fromApi = Number(apiHours);
  if (Number.isFinite(fromApi) && fromApi > 0) return fromApi;
  return PAYROLL_DEFAULT_MONTHLY_HOURS;
}

/** Default PTO hours when timesheet PTO line has 0 logged hours. */
export function payrollPtoDefaultDayHoursForEmpOutId(empOutId, apiHours) {
  const monthlyTarget = payrollMonthlyTargetHoursForEmpOutId(empOutId, apiHours);
  if (monthlyTarget === 117) return PAYROLL_PTO_DAY_HOURS_117_SCHEDULE;
  return PAYROLL_DEFAULT_PTO_DAY_HOURS;
}
